import { GlobalResponseObject } from "@schemax-whatsapp/shared-models/common";
import { GymEmployeesModel } from "./gym-employees.model";

export class GymEmployeesResponse extends GlobalResponseObject {
    data?: GymEmployeesModel[];
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: GymEmployeesModel[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}